/**
 * 密码输入框
 */
import "./index.scss";

import _ from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";

import { HoldModel } from "@/shared/decorators/hold-model";

@Component({ name: "PasswordCells" })
export default class PasswordCells extends Vue {
  @HoldModel()
  private password!: string;

  @Prop({
    type: Number,
    default: 6,
  })
  private length!: number;

  private render() {
    return (
      <div v-class>
        {_.range(this.length).map((i) => (
          <span v-class={["cell", { filled: this.password.length > i }]}>
            ·
          </span>
        ))}
      </div>
    );
  }
}
